import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

class NoctilFeatures extends Component {
  render() {
    return (
      <div className="container noctil-features">
        <div className="pt--80">
          <div className="row">
            <div className="col-md-12 text-center">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                <h2>Explore the possibilities with Noctil</h2>
              </ScrollAnimation>
            </div>
            <div className="col-md-6 feature-block mt--40">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={100}>
                <div className="row d-flex">
                  <div className="col-md-6 text-center">
                    <img
                      src="/assets/images/features/get-rid-of-metadata-challenges.svg"
                      alt="Get Rid of Metadata Challenges"
                    />
                  </div>
                  <div className="col-md-6">
                    <h4>Get Rid of Metadata Challenges and improve quality</h4>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-md-6 feature-block mt--40">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={150}>
                <div className="row d-flex">
                  <div className="col-md-6 text-center">
                    <img
                      src="/assets/images/features/identify-and-match-like-never-before.svg"
                      alt="Identify and Match Like Never Before"
                    />
                  </div>
                  <div className="col-md-6 pr--0">
                    <h4>Identify and Match Like Never Before</h4>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-md-6 feature-block">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={200}>
                <div className="row d-flex">
                  <div className="col-md-6 text-center">
                    <img
                      src="/assets/images/features/increase-revenue-and-make-your-customers-happy.svg"
                      alt="Increase Revenue and Make Your Customers Happy"
                    />
                  </div>
                  <div className="col-md-6">
                    <h4>Increase Revenue and Make Your Customers Happy</h4>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-md-6 feature-block">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={250}>
                <div className="row d-flex">
                  <div className="col-md-6 text-center">
                    <img
                      src="/assets/images/features/reduce-operational-costs.svg"
                      alt="Reduce Operational Costs"
                    />
                  </div>
                  <div className="col-md-6 pr--0">
                    <h4>Cut down operational and tech costs</h4>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-md-6 feature-block">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={250}>
                <div className="row d-flex">
                  <div className="col-md-6 text-center">
                    <img
                      src="/assets/images/features/accelerate-metadata-proc.png"
                      alt="Reduce Operational Costs"
                    />
                  </div>
                  <div className="col-md-6 pr--0">
                    <h4>Accelerate metadata processing in bulk</h4>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div className="col-md-6 feature-block">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={250}>
                <div className="row d-flex gap-1">
                  <div className="col-md-6 text-center">
                    <img
                      src="/assets/images/features/empower-artist-lives.png"
                      alt="Reduce Operational Costs"
                    />
                  </div>
                  <div className="col-md-6 pr--0">
                    <h4>
                      Empower Artist’s lives by offering them customized monthly impact
                      reports
                    </h4>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NoctilFeatures;
